import { render, staticRenderFns } from "./ProfileEducationCard.vue?vue&type=template&id=4d20e4cd"
import script from "./ProfileEducationCard.vue?vue&type=script&lang=ts"
export * from "./ProfileEducationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d20e4cd')) {
      api.createRecord('4d20e4cd', component.options)
    } else {
      api.reload('4d20e4cd', component.options)
    }
    module.hot.accept("./ProfileEducationCard.vue?vue&type=template&id=4d20e4cd", function () {
      api.rerender('4d20e4cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/ProfileEducationCard.vue"
export default component.exports